import React from 'react'
import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import * as S from '../CarecoAdminDashboard/CarecoAdminStyle'
import * as St from '../TopQueries/TopQueryStyle'
import { RightIcon, pendingActionIcon as PendingActionIcon } from 'uiKit/icons/Icons'
import { isProfessionalsNavAllowed } from 'tabs/home/api/usageLimits'

const StyledContainer = styled(S.Container)`
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledCard = styled(St.Card)`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 292px;
  max-height:292px;
  overflow-y:auto;
`

const EmptyStateWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
`

const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`

const EmptyStateText = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  color: #616581;
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`

const Tag = styled.span<{ $tagType: 'invitation' | 'review' }>`
  padding: 4px 12px;
  border-radius: 4px;
  /* Invitation = hawkes-blue (CareBrain ice); Review = badge-review (CareBrain lilac).
     Both remap to pine tint under data-brand=qcs — CareBrain defaults unchanged. */
  background-color: ${({ $tagType }) => {
    return $tagType === 'invitation'
      ? 'var(--color-hawkes-blue)'
      : 'var(--color-badge-review)'
  }};
  color: var(--color-text-secondary);
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
`

type PendingActionItem = {
  statusName: string
  employeeCount: number
  message: string
}

interface PendingActiionProps extends RouteComponentProps {
  data?: PendingActionItem[] | null
  activeBot?: any
}

const PendingActiion: React.FC<PendingActiionProps> = ({ data, activeBot, match, history }) => {
  const { botId: routeBotId } = (match as any)?.params || {}
  const botId = routeBotId || activeBot?.id
  const items: PendingActionItem[] = Array.isArray(data) ? data : []

  if (!isProfessionalsNavAllowed(activeBot)) {
    return null
  }

  const getTagInfo = (statusName: string) => {
    const isPendingUser = statusName.toLowerCase().includes('pending user')
    return {
      label: isPendingUser ? 'Invitation' : 'Review',
      type: isPendingUser ? 'invitation' as const : 'review' as const
    }
  }

  const handleItemClick = (statusName: string) => {
    if (!botId) return
    const name = (statusName || '').trim().toLowerCase()
    if (name === 'review pending' || name === 'negative flow' || name === 'overdue') {
      history.push(`/admin/bot/${botId}/dashboard/supervision`)
    } else {
      history.push(`/admin/bot/${botId}/professionals`)
    }
  }
  return (
    <StyledContainer>
      <S.SectionTitle>Pending actions </S.SectionTitle>
      <StyledCard>
        {items.length === 0 ? (
          <EmptyStateWrapper>
            <EmptyStateContent>
              <PendingActionIcon />
              <EmptyStateText>No pending action</EmptyStateText>
            </EmptyStateContent>
          </EmptyStateWrapper>
        ) : (
          items.map((item, index) => (
            <St.QueryContent
              onClick={() => handleItemClick(item.statusName)}
              key={index + item.statusName}>
              <St.QueryTitle>{item.message}</St.QueryTitle>
              <ContentWrapper>
                <Tag $tagType={getTagInfo(item.statusName).type}>
                  {getTagInfo(item.statusName).label}
                </Tag>
                <RightIcon size={20} />
              </ContentWrapper>
            </St.QueryContent>
          ))
        )}
      </StyledCard>
    </StyledContainer>
  )
}

const mapStateToProps = (state: any) => ({
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(withRouter(PendingActiion))
